<template>
  <Popover title="Editar" placement="bottom">
    <button
      id="botaoEditar"
      data-test-id="button-botaoeditar"
      name="botaoEditar"
      type="button"
      class="btn btn-sm btn-default tw-w-full"
      data-role="trigger"
    >
      <span class="fa fa-edit" />
    </button>
    <template #popover>
      <div class="tw-min-w-96 -tw-ml-6 -tw-mr-6">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div class="form-group">
            <label>Nome (*)</label>
            <input
              id="campoNome"
              v-model="agendamento.paciente.nome"
              data-test-id="input-camponome"
              :disabled="agendamento.paciente.valido"
              name="campoNome"
              type="text"
              class="form-control input-sm"
            />
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div class="form-group">
            <label>Contato (*)</label>
            <input
              id="campoContato"
              v-model="agendamento.paciente.telefone"
              v-mask="'(99) 999999999'"
              data-test-id="input-campocontato"
              :disabled="agendamento.paciente.valido"
              name="campoContato"
              type="text"
              class="form-control input-sm"
            />
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div class="form-group">
            <label>Data de Nascimento (*)</label>
            <input
              id="campoDataNascimento"
              v-model="agendamento.paciente.data_nascimento"
              v-mask="'99/99/9999'"
              data-test-id="input-campodatanascimento"
              :disabled="agendamento.paciente.valido"
              name="campoDataNascimento"
              type="text"
              class="form-control input-sm"
            />
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div class="form-group">
            <div v-show="!agendamento.paciente.valido" class="checkbox">
              <label>
                <input
                  id="checkPreAgendado"
                  v-model="agendamento.paciente.preAgendamento"
                  data-test-id="input-checkpreagendado"
                  name="checkPreAgendado"
                  type="checkbox"
                />
                Pré-agendamento
              </label>
            </div>
            <div
              v-show="agendamento.avaliacao || !agendamento.statusAtual"
              class="checkbox"
            >
              <label>
                <input
                  id="checkAvaliacao"
                  v-model="agendamento.avaliacao"
                  data-test-id="input-checkavaliacao"
                  type="checkbox"
                  name="checkAvaliacao"
                  :disabled="agendamento.statusAtual"
                />
                Avaliação
              </label>
            </div>
          </div>
        </div>
        <div v-if="encaixe" class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div class="form-group">
            <label>Hora (*)</label>
            <select
              id="campoHora"
              v-model="horaEncaixe"
              data-test-id="select-campohora"
              name="campoHora"
              class="form-control input-sm"
            >
              <option v-for="h in horasDisponiveis" :key="h" :value="h">{{
                h
              }}</option>
            </select>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div class="form-group">
            <label>Observações</label>
            <textarea
              id="campoObservacoes"
              v-model="agendamento.observacao"
              data-test-id="textarea-campoobservacoes"
              name="campoObservacoes"
              class="form-control input-sm"
              style="resize: none"
              rows="3"
            />
          </div>
        </div>
      </div>
      <div
        v-if="agendamento._id && isObjectIdValido(agendamento.paciente._id)"
        class="row"
      >
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <button
            data-test-id="button-emit-9"
            type="button"
            class="btn btn-sm btn-primary btn-block"
            @click="$emit('imprimirEtiqueta')"
          >
            Imprimir etiqueta
          </button>
        </div>
      </div>
    </template>
  </Popover>
</template>

<script>
import AwesomeMask from 'awesome-mask'

import Popover from '@/componentes/ui/popover/Popover.vue'
import STATUS_AGENDAMENTO from '@/constantes/dominio/STATUS_AGENDAMENTO'
import ControleAcessoServico from '@/servicos/ControleAcessoServico'
import { isObjectIdValido } from '@/utils/object-id'

const controleAcessoServico = new ControleAcessoServico()

export default {
  name: 'AgendamentoEditar',
  components: { Popover },
  directives: { mask: AwesomeMask },
  props: {
    agendamento: {
      type: Object,
      required: true,
    },
    horasDisponiveis: {
      type: Array,
      required: false,
      default() {
        return []
      },
    },
    hora: {
      type: String,
      required: false,
      default() {
        return ''
      },
    },
    encaixe: {
      type: Boolean,
      required: false,
      default() {
        return false
      },
    },
  },
  data() {
    return {
      horaEncaixe: this.hora,
    }
  },
  watch: {
    'agendamento.paciente.preAgendamento'() {
      this.alterarStatusPreAgendamento()
    },
    horaEncaixe() {
      this.$emit('atualizarHora', this.agendamento, this.horaEncaixe)
    },
  },
  methods: {
    isObjectIdValido,
    alterarStatusPreAgendamento() {
      this.agendamento.status = ''
      this.agendamento.statusAgendamentoSeguintes = []

      const preAgendando = STATUS_AGENDAMENTO.valores.find(
        (x) => x.id === 'pre_agendado'
      )
      const marcado = STATUS_AGENDAMENTO.valores.find((x) => x.id === 'marcado')

      if (
        this.agendamento.paciente.preAgendamento &&
        this.agendamento.statusAtual !== 'Pré-agendado'
      ) {
        if (controleAcessoServico.verificaAcao('agendamento_pre_agendado')) {
          this.agendamento.statusAgendamentoSeguintes = [preAgendando]
        }
      } else {
        if (controleAcessoServico.verificaAcao('agendamento_marcado')) {
          this.agendamento.statusAgendamentoSeguintes = [marcado]
        }
      }
    },
  },
}
</script>
